<div class="form-wrapper">
  <div class="form-title body-3xl md_body-5xl">{{title()}}</div>
  <div class="content p-lg sm_p-xl">
    <ng-content></ng-content>
  </div>
</div>

